module.exports = require('../../full/object/assign');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/features/object/assign.js
// module id = 1271
// module chunks = 25